import { TFunction } from 'i18next';

export type SubscriptionDurationOption = {
	name: string;
	description?: string;
	duration: number;
	discount: number;
	header: string;
};

export const getSubscriptionDurationOptions = (t: TFunction): SubscriptionDurationOption[] => [
	{
		name: 'Monthly',
		duration: 1,
		discount: 0,
		header: `${t('plans.applyAutomaticDiscountForLessSales', {
			discount: 0.5 * 100,
			sales: '$1,000',
			defaultValue:
				'We apply an automatic {{discount}}% discount to your subscription for every month you made less than {{sales}} in sales',
		})}.`,
	},
	{
		name: 'Yearly',
		description: 'Save 10%',
		duration: 12,
		discount: 0.1,
		header: `${t('plans.applyAutomaticDiscountForCommitment', {
			discount: 0.1 * 100,
			savings: '$470',
			defaultValue:
				'We apply an automatic {{discount}}% discount to your subscription for your commitment which saves you up to {{savings}}',
		})}.`,
	},
	{
		name: '2 years',
		description: 'Save 20%',
		duration: 24,
		discount: 0.2,
		header: `${t('plans.applyAutomaticDiscountForCommitment', {
			discount: 0.2 * 100,
			savings: '$1,900',
			defaultValue:
				'We apply an automatic {{discount}}% discount to your subscription for your commitment which saves you up to {{savings}}',
		})}.`,
	},
];
